import * as Sentry from '@sentry/angular';

const DIAGNOSTICS_KEY = 'ngswRecoveryDiagnostics';

/**
 * If index.html's watchdog script had to unregister a stuck service worker on the previous
 * load, it leaves a diagnostics blob behind in sessionStorage before reloading (see the
 * inline script in index.html for the failure mode this covers). Surfacing that as a Sentry
 * event here means a recurrence is visible without needing someone to catch it live in
 * DevTools.
 */
export class NgswRecoveryReporter {
  public static reportIfNeeded(): void {
    const diagnosticsRaw = this.consumeDiagnostics();

    if (!diagnosticsRaw) {
      return;
    }

    try {
      const diagnostics = JSON.parse(diagnosticsRaw) as Record<string, unknown>;

      Sentry.captureMessage('Auto-recovered from a stuck service worker', {
        extra: diagnostics,
        level: 'warning',
      });
    } catch {
      // Malformed diagnostics shouldn't block app startup.
    }
  }

  private static consumeDiagnostics(): string | null {
    try {
      const diagnosticsRaw = sessionStorage.getItem(DIAGNOSTICS_KEY);

      sessionStorage.removeItem(DIAGNOSTICS_KEY);

      return diagnosticsRaw;
    } catch {
      return null;
    }
  }
}
